// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.fixed-tools_row_sMEDt {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.fixed-tools_costume-input_X_2mo {
  width: 8rem;
}

[dir='ltr'] .fixed-tools_mod-dashed-border_UeIV9 {
  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-right: calc(2 * 0.25rem);
}

[dir='rtl'] .fixed-tools_mod-dashed-border_UeIV9 {
  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-left: calc(2 * 0.25rem);
}

.fixed-tools_mod-unselect_QyiuP {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.fixed-tools_button-group-button_OjrjF {
  display: inline-block;
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-radius: 0;
  padding: 0.35rem;
}

[dir='ltr'] .fixed-tools_button-group-button_OjrjF {
  border-left: none;
}

[dir='rtl'] .fixed-tools_button-group-button_OjrjF {
  border-right: none;
}

[dir='ltr'] .fixed-tools_button-group-button_OjrjF:last-of-type {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

[dir='ltr'] .fixed-tools_button-group-button_OjrjF:first-of-type {
  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

[dir='rtl'] .fixed-tools_button-group-button_OjrjF:last-of-type {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

[dir='rtl'] .fixed-tools_button-group-button_OjrjF:first-of-type {
  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

[dir='ltr'] .fixed-tools_button-group-button_OjrjF.fixed-tools_mod-start-border_dNzno {
  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

[dir='rtl'] .fixed-tools_button-group-button_OjrjF.fixed-tools_mod-start-border_dNzno {
  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

[dir='ltr'] .fixed-tools_button-group-button_OjrjF.fixed-tools_mod-no-end-border_G9rx6 {
  border-right: none;
}

[dir='rtl'] .fixed-tools_button-group-button_OjrjF.fixed-tools_mod-no-end-border_G9rx6 {
  border-left: none;
}

.fixed-tools_button-group-button-icon_Wj_v_ {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: middle;
}

[dir='rtl'] .fixed-tools_button-group-button-icon_Wj_v_ {
  -webkit-transform: scaleX(-1);
      -ms-transform: scaleX(-1);
          transform: scaleX(-1);
}

.fixed-tools_mod-context-menu_FUdop {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
      -ms-flex-direction: column;
          flex-direction: column;
}

.fixed-tools_mod-top-divider_uPijm {
  border-top: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

.fixed-tools_mod-menu-item_NpXth {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 -0.25rem;
  min-width: 6.25rem;
  padding: calc(3 * 0.25rem);
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: 0.1s ease;
  transition: 0.1s ease;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
}

.fixed-tools_mod-disabled_IyC_R {
  cursor: auto;
}

.fixed-tools_mod-menu-item_NpXth:hover {
  background: var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.fixed-tools_mod-disabled_IyC_R:hover {
  background-color: transparent;
}

.fixed-tools_menu-item-icon_laChE {
  margin-right: calc(2 * 0.25rem);
  width: 1.25rem;
  height: 1.25rem;
}

[dir='rtl'] .fixed-tools_menu-item-icon_laChE {
  margin-right: 0;
  margin-left: calc(2 * 0.25rem);
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/fixed-tools/fixed-tools.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;EACtD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;EAC3D,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,4DAA4D;EAC5D,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;MACzB,yBAAyB;UACrB,qBAAqB;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;MAC1B,0BAA0B;UACtB,sBAAsB;AAChC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;EAC3B,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;;CAGD;AACD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.costume-input {\n  width: 8rem;\n}\n\n[dir='ltr'] .mod-dashed-border {\n  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .mod-dashed-border {\n  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-left: calc(2 * 0.25rem);\n}\n\n.mod-unselect {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.button-group-button {\n  display: inline-block;\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-radius: 0;\n  padding: 0.35rem;\n}\n\n[dir='ltr'] .button-group-button {\n  border-left: none;\n}\n\n[dir='rtl'] .button-group-button {\n  border-right: none;\n}\n\n[dir='ltr'] .button-group-button:last-of-type {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n[dir='ltr'] .button-group-button:first-of-type {\n  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n[dir='rtl'] .button-group-button:last-of-type {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n[dir='rtl'] .button-group-button:first-of-type {\n  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n[dir='ltr'] .button-group-button.mod-start-border {\n  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n[dir='rtl'] .button-group-button.mod-start-border {\n  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n[dir='ltr'] .button-group-button.mod-no-end-border {\n  border-right: none;\n}\n\n[dir='rtl'] .button-group-button.mod-no-end-border {\n  border-left: none;\n}\n\n.button-group-button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  vertical-align: middle;\n}\n\n[dir='rtl'] .button-group-button-icon {\n  -webkit-transform: scaleX(-1);\n      -ms-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n\n.mod-context-menu {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.mod-top-divider {\n  border-top: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n.mod-menu-item {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -0.25rem;\n  min-width: 6.25rem;\n  padding: calc(3 * 0.25rem);\n  white-space: nowrap;\n  cursor: pointer;\n  -webkit-transition: 0.1s ease;\n  transition: 0.1s ease;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, sans-serif;\n}\n\n.mod-disabled {\n  cursor: auto;\n}\n\n.mod-menu-item:hover {\n  background: var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.mod-disabled:hover {\n  background-color: transparent;\n}\n\n.menu-item-icon {\n  margin-right: calc(2 * 0.25rem);\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n[dir='rtl'] .menu-item-icon {\n  margin-right: 0;\n  margin-left: calc(2 * 0.25rem);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `fixed-tools_row_sMEDt`,
	"costume-input": `fixed-tools_costume-input_X_2mo`,
	"costumeInput": `fixed-tools_costume-input_X_2mo`,
	"mod-dashed-border": `fixed-tools_mod-dashed-border_UeIV9`,
	"modDashedBorder": `fixed-tools_mod-dashed-border_UeIV9`,
	"mod-unselect": `fixed-tools_mod-unselect_QyiuP`,
	"modUnselect": `fixed-tools_mod-unselect_QyiuP`,
	"button-group-button": `fixed-tools_button-group-button_OjrjF`,
	"buttonGroupButton": `fixed-tools_button-group-button_OjrjF`,
	"mod-start-border": `fixed-tools_mod-start-border_dNzno`,
	"modStartBorder": `fixed-tools_mod-start-border_dNzno`,
	"mod-no-end-border": `fixed-tools_mod-no-end-border_G9rx6`,
	"modNoEndBorder": `fixed-tools_mod-no-end-border_G9rx6`,
	"button-group-button-icon": `fixed-tools_button-group-button-icon_Wj_v_`,
	"buttonGroupButtonIcon": `fixed-tools_button-group-button-icon_Wj_v_`,
	"mod-context-menu": `fixed-tools_mod-context-menu_FUdop`,
	"modContextMenu": `fixed-tools_mod-context-menu_FUdop`,
	"mod-top-divider": `fixed-tools_mod-top-divider_uPijm`,
	"modTopDivider": `fixed-tools_mod-top-divider_uPijm`,
	"mod-menu-item": `fixed-tools_mod-menu-item_NpXth`,
	"modMenuItem": `fixed-tools_mod-menu-item_NpXth`,
	"mod-disabled": `fixed-tools_mod-disabled_IyC_R`,
	"modDisabled": `fixed-tools_mod-disabled_IyC_R`,
	"menu-item-icon": `fixed-tools_menu-item-icon_laChE`,
	"menuItemIcon": `fixed-tools_menu-item-icon_laChE`
};
export default ___CSS_LOADER_EXPORT___;
